import React from 'react'
import EmailField from 'Event/auth/Login/EmailField'
import Page, {
  StyledFormContainer,
  DescriptionText,
} from 'Event/template/Townhall/Login/Page'
import {SignUpProps} from 'Event/auth/SignUp'
import {useTownhallTemplate} from 'Event/template/Townhall'
import Description from 'Event/auth/SignUp/Description'
import SubmitButton from 'Event/auth/SignUp/SubmitButton'
import FirstNameField from 'Event/auth/SignUp/FirstNameField'
import LastNameField from 'Event/auth/SignUp/LastNameField'
import PhoneNumberField from 'Event/auth/SignUp/PhoneNumberField'
import SignUpAdditionalFields from 'Event/auth/SignUp/SignUpAdditionalFields'
import ErrorMessage from 'Event/auth/SignUp/ErrorMessage'
import {useGuestVariables} from 'Event'
import Visible from 'lib/ui/layout/Visible'

export default function SignUp(props: SignUpProps) {
  return (
    <Page isPreview={false}>
      <StyledFormContainer>
        <Content {...props} />
      </StyledFormContainer>
    </Page>
  )
}

export function Content(props: SignUpProps) {
  const {signUp} = useTownhallTemplate()
  const v = useGuestVariables()

  return (
    <>
      <Description
        aria-label="event sign up description"
        Component={DescriptionText}
      >
        {v(signUp.description)}
      </Description>
      <form onSubmit={props.onSubmit}>
        <FirstNameField {...props} />
        <LastNameField {...props} />
        <EmailField {...props} />
        <Visible when={signUp.hasPhoneNumberField}>
          <PhoneNumberField {...props} />
        </Visible>
        <SignUpAdditionalFields {...props} />
        <ErrorMessage error={props.responseError?.message} />
        <SubmitButton {...props} />
      </form>
    </>
  )
}
